import React from "react";
import ProgressBar from "./components/ProgressBar";
import NetworkBanner from "./components/alerts/NetworkBanner";
import useAuth from "./hooks/useAuth";

function Login() {
    const { shouldShowProgressBar, isApiError } = useAuth();

    return (
        <div>
            {shouldShowProgressBar && <ProgressBar />}

            <NetworkBanner
                onlyOnPath="/login"
                enabled={true}
                isApiError={isApiError}
                apiErrorMessage="Login failed, please try again or contact us for further assistance."
            />
        </div>
    );
}

export default Login;
